import { ArrowPathIcon } from "@heroicons/react/24/solid";

export default function LoadingSpinner({className}){
    return(
        <span className={`animate-spin block ${className || 'w-[1rem]'}`}>
            <ArrowPathIcon />
        </span>
    )
}